import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import NoImage from "../../assets/images/NoImages.png";
import { useDispatch, useSelector } from "react-redux";
import { inspectionSelector, removePhoto } from "../../redux/inspectionSlice";

const ImageUploadedList = () => {
  const { photos } = useSelector(inspectionSelector) || [];
  const dispatch = useDispatch();

  const isImage = (url) => {
    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
  }

  return (
    <>
      {photos &&
        photos.length > 0 &&
        photos.map((photo, id) => (
          <div className="mediaImages" key={id}>
            <Link to="#">
              <div className="images">
                {isImage(photo) ? 
                <img src={photo} alt="" /> : 
                <Icon icon="bi:filetype-doc" width="30" height="30" />
              }
              </div>
            </Link>
            {/* <div className="media-body">{imageInfo.imageName}</div> */}
            <Link
              to="#"
              className="cta"
              onClick={() => dispatch(removePhoto(photo))}
            >
              <Icon icon="iconoir:cancel" />
            </Link>
          </div>
        ))}

      {(!photos || photos.length < 1) && (
        <div className="noImage">
          <img src={NoImage} alt="" />
          <span>No images yet</span>
        </div>
      )}
    </>
  );
};

export default ImageUploadedList;
